// @flow
import type {Node} from 'react'
import React, {Component} from 'react'

type Props = {
  onChange: Function,
  text: string,
}

type State = {
  roleDefinition: string,
}

class EditForm extends Component<Props, State> {
  state: State = {
    roleDefinition: '',
  }

  render(): Node {
    return (
      <div className="paste-role-form">
        <textarea
          className="form-control role-definition-text"
          placeholder={I18n.t('proposals.react.paste_role_placeholder')}
          value={this.props.text}
          onChange={this.props.onChange}
          rows="5"
        />
        <small className="form-text text-muted">
          {I18n.t('proposals.react.paste_role_definition_instructions')}
          {' '}
          {I18n.t('proposals.react.paste_role_definition_must_be_english')}
        </small>
      </div>
    )
  }
}

export default EditForm
